<template>
  <div class="step-wrapper">
    <div class="step-wrapper-subject"><strong>step 4 | select alignment</strong></div>
    <!--div class="step-wrapper-description mt-4">Note: Alignment selection does not show in preview box below, but your information is transmitted with order.</div-->
    <!--b-link class="more-info mt-4" v-b-modal.modal-align>More Info</b-link-->
    <div class="step-wrapper-aligns mt-4">
      <b-button v-on:click="selectAlign" data-align="left"><i class="fa fa-align-left"></i></b-button>
      <b-button v-on:click="selectAlign" class="active" data-align="center"><i class="fa fa-align-center"></i></b-button>
      <b-button v-on:click="selectAlign" data-align="right"><i class="fa fa-align-right"></i></b-button>
    </div>
    <b-button variant="default" class="mt-4 go-next" v-on:click="goNext">next</b-button>

    <b-modal id="modal-align" centered size="lg" title="Alignment">
      <p class="my-4">Vertically centered modal!</p>
    </b-modal>
    </div>
</template>

<script>
import jQuery from 'jquery'

export default {
  components: {
    jQuery
  },
  data() {
    return {
      stencileaseAlignment: this.$store.state.product.textAlign
    }
  },
  methods: {
    selectAlign(evt) {
      let obj = evt.target
      let parent = obj.tagName.toLowerCase() == 'button'? jQuery(obj): jQuery(obj).parent();
      this.stencileaseAlignment = jQuery(parent).data('align')

      jQuery('.step-wrapper-aligns .btn').removeClass('active');
      jQuery(parent).addClass('active');

      this.$store.dispatch('product/SET_ALIGN', this.stencileaseAlignment)
    },
    goNext(evt) {
      this.$store.dispatch('product/SET_OLDTAB', 3)

      this.$store.dispatch('product/SET_ACTIVETAB', 3)
      this.$store.dispatch('product/SET_ACTIVETAB', 4)
    }
  }
}
</script>
